"use client";

import React from 'react';
import { Background } from '../../components/home/Background';
import { Footer } from '../../components/footer/Footer';

// This prevents static generation for auth pages
export const dynamic = 'force-dynamic';

export default function AuthLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <Background className="fixed inset-0 -z-10" />
      <div className="w-full relative z-10 pt-32 pb-20">
        {children}
      </div>
      <Footer />
    </>
  );
} 